module.exports = __webpack_public_path__ + "static/media/stronghold.22d05dde.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/partners/stronghold.png
// module id = 419
// module chunks = 0